import {http} from '@/utils/http'
import {IAccountConfirm, IAccountEnd, IAccounts, IAccountStart} from "@/features/account/account.types";
import {AxiosResponse} from "axios";

export const accountService = {
    getAccounts(): Promise<AxiosResponse<IAccounts>> {
        return http.get('/accounts')
    },

    startAccount(payload: IAccountStart): Promise<AxiosResponse> {
        return http.post('/accounts/login/start', payload)
    },

    confirmAccount(payload: IAccountConfirm): Promise<AxiosResponse> {
        return http.post('/accounts/login/confirm', payload)
    },

    accountActivity(sessionName: string): Promise<AxiosResponse> {
        return http.get(`/accounts/${sessionName}/activity`)
    },

    endAccount(sessionName: string, payload: IAccountEnd): Promise<AxiosResponse> {
        return http.post(`/accounts/${sessionName}/sessions/end`, payload)
    },

    accountReconnect(account_id: string, payload: any): Promise<AxiosResponse> {
        return http.post(`/accounts/${account_id}/reconnect/start`, payload)
    },

    confirmReconnect(account_id: string, payload: any): Promise<AxiosResponse> {
        return http.post(`/accounts/${account_id}/reconnect/confirm`, payload)
    }
}